import * as aliadas from './aliadas'
import * as services from './services'
import * as recurrences from './recurrences'
import * as auth from './auth'
import * as promotionalCode from './promotional-code'
import * as users from './users'
import * as orders from './orders'

export {
  aliadas,
  services,
  recurrences,
  auth,
  promotionalCode,
  users,
  orders,
}



// WEBPACK FOOTER //
// ./src/services/api/index.js